module.exports = __webpack_public_path__ + "static/airplane-e6b875e1c44618cb814510fa68661773.png";